import { IAuthContext } from "@/interfaces"
import { ICategoryItem, IListItems } from "@/interfaces/components"
import { currentTheme } from "@/utils/currentTheme"
import firebase from "firebase/compat/app"
const listGroupLocal = [
  {
    id: "1",
    name: "Frutas",
  },
  {
    id: "2",
    name: "Verduras",
  },
  {
    id: "3",
    name: "Carnes",
  },
  {
    id: "4",
    name: "Abarrotes",
  },
  {
    id: "5",
    name: "InkaFarma",
  },
]

export const initialState: IAuthContext = {
  user: {} as firebase.User,
  accessToken: "",
  metadata: {},
  loading: "idle",
  isUser: false,
  theme: currentTheme(),
  listCategory: listGroupLocal as ICategoryItem[],
  listGroups: [] as IListItems[],
} as IAuthContext
